import { Grid } from '@mui/material'
import { Child } from '../../../../containers/common/child'
import { UnitTitle } from './unitTitle'
import { OperationId } from '../../../../containers/common/constant/operationLog'
import { GetCategoryMstDto } from '../../../../dataAccess/webApi/dto/categoryMstDto'
import { memberModifyChildBirthUrl } from '../../../../containers/common/constant/appUrl'
import styled from '@emotion/styled'
import { translate } from '../../../../i18n'
import { Flag } from '../../../../containers/common/constant/classification'

export const CATEGORY_NAMES = ['birthHeight', 'birthWeight']

interface ChildBirthUnitProps {
  child?: Child
  sectionLabel: string
  categoryMst?: GetCategoryMstDto[]
  hideLink?: boolean
  LabelItem: any
  ValueItem: any
}

export const ChildBirthUnit = (props: ChildBirthUnitProps) => {
  const { categoryMst, child, sectionLabel, LabelItem, ValueItem } = props
  if (child == null || categoryMst == null || categoryMst.length === 0) return null

  const targetCategories = categoryMst
    ?.filter((value) => CATEGORY_NAMES.includes(value.category) && value.displayCitizen === Flag.ON)
    .sort((a, b) => CATEGORY_NAMES.indexOf(a.category) - CATEGORY_NAMES.indexOf(b.category))
  if (targetCategories == null || targetCategories.length === 0) return null

  const categoryMap: { [key: string]: GetCategoryMstDto } = {}
  targetCategories?.forEach((e) => (categoryMap[e.category] = e))

  const ChildContentAttribute = styled(Grid)({
    padding: '0 0 0 3rem',
  })

  const unSetLabel = translate('system.childContent.label.notSet')

  return (
    <>
      <UnitTitle
        title={sectionLabel}
        linkTo={memberModifyChildBirthUrl.url(child.childId)}
        operationLog={{ operationId: OperationId.OP_00000189 }}
        hideLink={props.hideLink}
      />
      <Grid container>
        <ChildContentAttribute container>
          {targetCategories.map((c, _) => {
            return (
              <DataRow
                key={c.category}
                category={c}
                child={child}
                LabelItem={LabelItem}
                ValueItem={ValueItem}
                unSetLabel={unSetLabel}
              />
            )
          })}
        </ChildContentAttribute>
      </Grid>
    </>
  )
}

interface DataRowProps {
  category: GetCategoryMstDto
  child: Child
  LabelItem: any
  ValueItem: any
  unSetLabel: string
}

const DataRow = ({ category, child, LabelItem, ValueItem, unSetLabel }: DataRowProps) => {
  const key = category.category as keyof Child
  const label = category.altCategoryName ?? category.name
  return (
    <>
      {label != null && label !== '' && <LabelItem>{label}</LabelItem>}
      {key === 'birthHeight' && <ValueItem>{child[key] ? `${child[key]}cm` : unSetLabel}</ValueItem>}
      {key === 'birthWeight' && <ValueItem>{child[key] ? `${child[key]}g` : unSetLabel}</ValueItem>}
    </>
  )
}